import React from 'react';
import { clsx } from 'clsx';
import { useTranslation } from 'react-i18next';
import { useItem, useItemCancelEarlyPayout } from '@/hooks/item';
import { useErrorHandling } from '@/hooks/common';
import { ItemCancelEarlyPayoutModal } from '@/types/modal';
import { ErrorModal, LoadingBodyModal, StandardModal, SuccessModal } from '@/components/molecules/common/Modal';
import styles from './Modal.module.scss';

const View: React.FC<{ modal: ItemCancelEarlyPayoutModal }> = ({ modal }) => {
  const { t } = useTranslation();
  const { item, onClose } = modal;

  const { getErrorMsgFromResponse } = useErrorHandling();

  const itemR = useItem(item.productId, false);
  const { mutate, isLoading, isSuccess, isError, error } = useItemCancelEarlyPayout(item.productId);

  if (isError) {
    return (
      <ErrorModal
        title={t('modal.item_cancel_early_payout.title')}
        message={getErrorMsgFromResponse(error)}
        onClose={onClose}
      />
    );
  } else if (isSuccess) {
    return (
      <SuccessModal
        title={t('modal.item_cancel_early_payout.title')}
        onClose={onClose}
      />
    );
  }

  const body = isLoading ? (
    <LoadingBodyModal height={40} />
  ) : (
    <div className={clsx([styles.text1rem, styles.paddingY1rem])}>
      <div dangerouslySetInnerHTML={{ __html: t('modal.item_cancel_early_payout.body', item) }} />
    </div>
  );

  return (
    <StandardModal
      title={t('modal.item_cancel_early_payout.title')}
      onClose={onClose}
      onSubmit={() => mutate(undefined, { onSuccess: () => itemR.refetch() })}
      closeLabel={t('common.no').toUpperCase()}
      submitLabel={t('common.yes').toUpperCase()}
      submittable={!isLoading}
      body={body}
      containerStyle={{ width: 500 }}
      modalName="item_cancel_early_payout"
    />
  );
};

export default View;
